import api from './api';
import imageLogo from '../Images/LogoEBNLogin.png';
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";
import dayjs from 'dayjs';



const factureService = {
  // Récupérer toutes les factures avec pagination et filtres
  getFactures: async (page = 1, perPage = 15, filters = {}) => {
    try {
      // Clean up filters to remove null/undefined values
      const cleanFilters = {};
      Object.keys(filters).forEach(key => {
        if (filters[key] !== null && filters[key] !== undefined && filters[key] !== '') {
          cleanFilters[key] = filters[key];
        }
      });

      const params = {
        page,
        per_page: perPage,
        ...cleanFilters
      };

      const response = await api.get('/factures', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des factures:', error);
      throw error;
    }
  },

  getFacturesByClientId: async (clientId) => {
    try {
      const response = await api.get(`/clients/${clientId}`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la récupération des factures pour le client ${clientId}:`, error);
      throw error;
    }
  },
  // Récupérer une facture spécifique
  getFacture: async (id) => {
    try {
      const response = await api.get(`/factures/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la récupération de la facture ${id}:`, error);
      throw error;
    }
  },

  getFactureExcel: async (id) => {
    try {
      const response = await api.get(`/factures-excel/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la récupération de la facture ${id}:`, error);
      throw error;
    }
  },

  // Récupérer les données pour créer une facture
  getCreateData: async (clientId, mois, annee) => {
    try {
      const params = {};
      if (clientId) params.client_id = clientId;
      if (mois) params.mois = mois;
      if (annee) params.annee = annee;

      const response = await api.get('/factures/create/data', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des données pour créer une facture:', error);
      throw error;
    }
  },

  // Récupérer les voyages non facturés pour un client et une période
  getNonFacturedVoyages: async (clientId, mois, annee) => {
    try {
      const params = {
        client_id: clientId,
        mois,
        annee
      };

      const response = await api.get('/voyages/non-factures', { params });
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des voyages non facturés:', error);
      throw error;
    }
  },

  getLingesVoyagesID: async (VoyageID) => {
    try {
      const response = await api.get(`/voyages/${VoyageID}/lignes`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération des voyages non facturés:', error);
      throw error;
    }
  },
  // Créer une nouvelle facture
  createFacture: async (factureData) => {
    try {
      const response = await api.post('/factures', factureData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la création de la facture:', error);
      throw error;
    }
  },

  // Mettre à jour une facture existante
  updateFacture: async (id, factureData) => {
    console.log(factureData);
    try {
      const response = await api.put(`/factures/${id}`, factureData);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la mise à jour de la facture ${id}:`, error);
      throw error;
    }
  },

  // Supprimer une facture
  deleteFacture: async (id) => {
    try {
      const response = await api.delete(`/factures/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Erreur lors de la suppression de la facture ${id}:`, error);
      throw error;
    }
  },

  // Générer des factures mensuelles automatiquement
  generateMonthlyFactures: async (mois, annee, clientIds = null) => {
    try {
      const data = {
        mois,
        annee
      };

      if (clientIds) {
        data.client_ids = clientIds;
      }

      const response = await api.post('/factures/generate-monthly', data);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la génération des factures mensuelles:', error);
      throw error;
    }
  },

  // Nettoyer les factures vides (avec montant 0)
  cleanupEmptyFactures: async () => {
    try {
      const response = await api.post('/factures/cleanup-empty');
      return response.data;
    } catch (error) {
      console.error('Erreur lors du nettoyage des factures vides:', error);
      throw error;
    }
  },

  // Réinitialiser les voyages non facturés
  resetNonInvoicedVoyages: async () => {
    try {
      const response = await api.post('/voyages/reset-non-invoiced');
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la réinitialisation des voyages non facturés:', error);
      throw error;
    }
  },

  generatePDFForEmail: async (facture) => {
    try {
      const { jsPDF } = await import("jspdf");
      const html2canvas = (await import("html2canvas")).default;
      const monthNames = [
        "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
        "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
      ];
      function numberToFrenchDirhams(number) {
        const units = [
          "", "un", "deux", "trois", "quatre", "cinq",
          "six", "sept", "huit", "neuf", "dix",
          "onze", "douze", "treize", "quatorze",
          "quinze", "seize", "dix-sept", "dix-huit", "dix-neuf"
        ];

        const tens = [
          "", "", "vingt", "trente", "quarante",
          "cinquante", "soixante", "soixante",
          "quatre-vingt", "quatre-vingt"
        ];

        function convertBelow100(n) {
          if (n < 20) return units[n];
          const ten = Math.floor(n / 10);
          const unit = n % 10;

          if (ten === 7 || ten === 9) {
            return tens[ten] + "-" + units[10 + unit];
          }

          if (unit === 0) return tens[ten];
          if (unit === 1 && ten !== 8) return tens[ten] + "-et-un";

          return tens[ten] + "-" + units[unit];
        }

        function convertBelow1000(n) {
          if (n < 100) return convertBelow100(n);

          const hundred = Math.floor(n / 100);
          const rest = n % 100;

          let result = hundred === 1 ? "cent" : units[hundred] + " cent";

          if (rest > 0) result += " " + convertBelow100(rest);

          return result;
        }

        function convertNumber(n) {
          if (n === 0) return "zéro";

          const thousands = Math.floor(n / 1000);
          const rest = n % 1000;

          let words = "";

          if (thousands > 0) {
            if (thousands === 1) {
              words += "mille";
            } else {
              words += convertBelow1000(thousands) + " mille";
            }
          }

          if (rest > 0) {
            words += (words ? " " : "") + convertBelow1000(rest);
          }

          return words;
        }

        const words = convertNumber(Math.round(number));
        return words.charAt(0).toUpperCase() + words.slice(1) + " Dirhams";
      }
      const pageDiv = document.createElement("div");

      pageDiv.style.cssText = `
      width: 794px;
      height: 1122px;
      background: white;
      font-family: Arial, sans-serif;
      border-left: 20px solid #D94F2A;
      padding: 40px;
      box-sizing: border-box;
      line-height: 1.6;
      letter-spacing: 1px;
      position: relative;
      display: flex;
      flex-direction: column;
    `;

      pageDiv.innerHTML = `
      <div style="height:100%;padding:10px;box-sizing:border-box;display:flex;flex-direction:column;justify-content:space-between;">
        
        <div>
          <div style="margin-bottom:30px;">
              <div style="display:flex;justify-content:space-between;align-items:flex-start;">
                <div>
                  <img src="${imageLogo}" style="height:40px;margin-bottom:10px;" />            
                </div>
                <div style="text-align:right;">
                <p style="font-size:8px;margin:0;">Facture N° : ${facture.numero_facture}</p>
                <p style="font-size:8px;margin:0;">Date : ${new Date(facture.date_facture).toLocaleDateString()}</p>
                </div>
              </div>
            </div>

          <div style="display:flex; justify-content:space-between; margin-bottom:40px; width:100%;">              
                <div style="width:40%; margin-bottom:30px;">
                  <h3 style="color:#D94F2A; margin-bottom:5px;">Coordonnées client</h3>
                  <p style="margin:0;"><strong>${facture.client?.Raison_sociale || facture.client?.Nom || 'NA'}</strong></p>
                  <p style="margin:0;">${facture.client?.Adresse || 'Adresse non renseignée'}</p>
                  <p style="margin:0;">ICE : ${facture.client?.ICE || 'NA'}</p>
                </div>

                <div style="width:40%; margin-bottom:30px; text-align:left;">
                  <h3 style="color:#D94F2A; padding-bottom:5px; margin-bottom:15px;">
                    Coordonnées bancaires
                  </h3>
                  <p style="margin:0;">RIB : 007 640 0002508000001585 78</p>
                  <p style="margin:0;">Domiciliation : Attijariwafa bank Ag. TANGER BEETHOVEN</p>
                </div>

              </div>

         

          <table style="width: 100%; border-collapse: collapse; margin-bottom: 40px; font-size: 14px;">
            <thead>
              <tr>
                <th style="padding: 10px; text-align: left; border: 1px solid #ccc; background: #f5f5f5;">Description</th>
                <th style="padding: 10px; text-align: center; border: 1px solid #ccc; background: #f5f5f5;">Qté</th>
                <th style="padding: 10px; text-align: center; border: 1px solid #ccc; background: #f5f5f5;">Prix unitaire</th>
                <th style="padding: 10px; text-align: center; border: 1px solid #ccc; background: #f5f5f5;">TOTAL</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="padding: 10px; border: 1px solid #ccc;">${facture.description || `Transport national Du Mois de ${monthNames[new Date(facture.date_facture).getMonth()]}`}</td>
                <td style="padding: 10px; text-align: center; border: 1px solid #ccc;">1</td>
                <td style="padding: 10px; text-align: center; border: 1px solid #ccc;">${Number(facture.montant_ht || 0).toFixed(2)} MAD</td>
                <td style="padding: 10px; text-align: center; border: 1px solid #ccc;">${Number(facture.montant_ht || 0).toFixed(2)} MAD</td>
              </tr>
            </tbody>
          </table>

          <div style="width:300px;margin-left:auto;font-size:14px;border:1px solid #ccc;border-radius:6px;padding:15px;">
            <table style="width:100%;border-collapse:collapse;">
              <tr>
                <td>Montant HT (MAD) :</td>
                <td style="text-align:right;">${Number(facture.montant_ht || 0).toFixed(2)}</td>
              </tr>
              <tr>
                <td>TVA :</td>
                <td style="text-align:right;">${Number(facture.montant_tva || 0).toFixed(2)}</td>
              </tr>
              <tr style="font-weight:bold;border-top:1px solid #ccc;">
                <td>Montant TTC (MAD) :</td>
                <td style="text-align:right;">${Number(facture.montant_ttc || 0).toFixed(2)}</td>
              </tr>
            </table>
          </div>

          <div style="margin-top:20px;">
            <p style="margin:0;font-size:10px;">
              Arrêté la présente facture à la somme de 
              ${numberToFrenchDirhams(facture.montant_ttc) || ""}
            </p>
          </div>
        </div>

        <div style="width:100%;height:100px;border:1px solid #000;margin:20px 0;display:flex;align-items:center;justify-content:center;">
          <div style="text-align:center;">
            <p style="margin:0;font-size:18px;font-weight:bold;">VISA ADV</p>
          </div>
        </div>

        <div style="font-size:9px;text-align:center;color:#666;border-top:1px solid #ccc;padding-top:10px;">
          <p>RC 83815 &nbsp;&nbsp; IF 2453806-1 &nbsp;&nbsp; CNSS 1622515 &nbsp;&nbsp; ICE 001966468000060</p>
          <p>EBN.LOGISTICS@GMAIL.COM &nbsp;&nbsp; www.ebnlogistics.com</p>
          <p>41, rue Desaix, Casablanca, Maroc</p>
        </div>

      </div>
    `;

      document.body.appendChild(pageDiv);

      const canvas = await html2canvas(pageDiv, {
        scale: 2,
        useCORS: true
      });

      const imgData = canvas.toDataURL("image/png");

      const pdf = new jsPDF("p", "mm", "a4");

      const pdfWidth = pdf.internal.pageSize.getWidth();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);

      document.body.removeChild(pageDiv);

      // RETURN BLOB (for email attachment)
      const pdfBlob = pdf.output("blob");

      return pdfBlob;

    } catch (error) {
      console.error("Erreur PDF EMAIL:", error);
      throw error;
    }
  },

  sendFactureByEmail: async (id) => {
    try {
      const facture = await factureService.getFacture(id);

      const pdfBlob = await factureService.generatePDFForEmail(facture);
      const excelBlob = await factureService.generateExcelForEmail(facture);

      const emailBody = `
Bonjour ${facture.client.Nom},

Veuillez trouver ci-joint la facture ${facture.numero_facture} ainsi que la liste des opérations.

Montant HT : ${facture.montant_ht} MAD
TVA : ${facture.montant_tva} MAD
Montant TTC : ${facture.montant_ttc} MAD

Cordialement,
EBN LOGISTICS
`;

      const formData = new FormData();
      formData.append("facture_id", facture.ID_Facture);
      formData.append("numero", facture.numero_facture);
      formData.append("client_email", facture.client.Email);
      formData.append("client_name", facture.client.Nom);
      formData.append("body", emailBody);

      // PDF
      formData.append(
        "pdf",
        pdfBlob,
        `facture-${facture.numero_facture}.pdf`
      );

      // EXCEL
      formData.append(
        "excel",
        excelBlob,
        `operations-${facture.numero_facture}.xlsx`
      );

      const response = await api.post(`/factures/${id}/send-email`, formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      return response.data;

    } catch (error) {
      console.error("Error sending facture email:", error);
      throw error;
    }
  },
  generateExcelForEmail: async (facture, imageLogoBase64 = null) => {
    try {
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet("Liste opérations");

      // === LOGO ===
      if (imageLogoBase64) {
        const logoId = workbook.addImage({
          base64: imageLogoBase64,
          extension: "png",
        });
        sheet.addImage(logoId, "A1:B3");
      }

      // === TITLE ===
      sheet.mergeCells("D1:F1");
      const titleCell = sheet.getCell("D1");
      titleCell.value = `LISTE DES OPERATIONS ${new Date(
        facture.date_facture
      ).toLocaleDateString("fr-FR")}`;
      titleCell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12 };
      titleCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "1D3E62" },
      };
      titleCell.alignment = { horizontal: "center", vertical: "middle" };

      // === COMMANDE ===
      sheet.mergeCells("D3:E3");
      sheet.getCell("D3").value = "COMMANDE N°";
      sheet.getCell("D3").alignment = { horizontal: "center", vertical: "middle" };
      sheet.getCell("D3").border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      sheet.getCell("F3").value = facture.numero_facture || "";
      sheet.getCell("F3").alignment = { horizontal: "center", vertical: "middle" };
      sheet.getCell("F3").border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      sheet.addRow([]);

      // === HEADER ===
      const headerRow = sheet.addRow([
        "Date chargement",
        "Expéditeur",
        "Destinataire",
        "Type moyen",
        "Prix HT",
        "N° CMR",
      ]);

      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "1D3E62" },
        };
        cell.font = { color: { argb: "FFFFFF" }, bold: true };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      // === DATA ===
      facture.lignes?.forEach(({ voyage }) => {
        if (!voyage) return;

        sheet.addRow([
          voyage.Date_chargement
            ? new Date(voyage.Date_chargement).toLocaleDateString("fr-FR")
            : "",
          voyage.Expediteur || "",
          voyage.Destinataire || "",
          voyage.Type_de_moyen || "",
          voyage.Coût_Total != null
            ? voyage.Coût_Total.toLocaleString("fr-FR", {
              minimumFractionDigits: 2,
            })
            : "",
          voyage.N_CMR || "",
        ]);

        if (voyage.Immobilisation?.toLowerCase() === "oui") {
          sheet.addRow([
            "", "", "", "Immobilisation",
            voyage.Prix_Immobilisation?.toLocaleString("fr-FR", {
              minimumFractionDigits: 2,
            }) || "",
            "",
          ]);
        }

        if (voyage.Prestation?.toLowerCase() === "oui") {
          sheet.addRow([
            "", "", "", "Prestation",
            voyage.Prix_Prestation?.toLocaleString("fr-FR", {
              minimumFractionDigits: 2,
            }) || "",
            "",
          ]);
        }
      });

      // === STYLE DATA ===
      sheet.eachRow((row, rowNumber) => {
        if (rowNumber > headerRow.number) {
          row.eachCell((cell) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
            cell.alignment = { horizontal: "center", vertical: "middle" };
          });
        }
      });

      // === TOTAL HT ===
      const totalRow = sheet.addRow([
        "", "", "", "TOTAL HORS TAXE",
        facture.montant_ht?.toLocaleString("fr-FR", {
          minimumFractionDigits: 2,
        }) || "",
        "",
      ]);

      totalRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "1D3E62" },
        };
        cell.font = { color: { argb: "FFFFFF" }, bold: true };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      // === SUMMARY ===
      const summaryStartRow = sheet.lastRow.number + 2;

      sheet.mergeCells(`D${summaryStartRow}:F${summaryStartRow}`);
      const recapCell = sheet.getCell(`D${summaryStartRow}`);
      recapCell.value = "Récapitulatif";
      recapCell.font = { color: { argb: "FFFFFF" }, bold: true };
      recapCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D94F2A" },
      };
      recapCell.alignment = { horizontal: "center", vertical: "middle" };

      sheet.getCell(`D${summaryStartRow + 1}`).value = "Total HT :";
      sheet.getCell(`E${summaryStartRow + 1}`).value = facture.montant_ht || 0;

      sheet.getCell(`D${summaryStartRow + 2}`).value = "TVA :";
      sheet.getCell(`E${summaryStartRow + 2}`).value = facture.montant_tva || 0;

      sheet.getCell(`D${summaryStartRow + 3}`).value = "Total TTC :";
      sheet.getCell(`E${summaryStartRow + 3}`).value = facture.montant_ttc || 0;
      sheet.getCell(`E${summaryStartRow + 3}`).font = {
        bold: true,
        color: { argb: "D94F2A" },
      };

      // === COLUMN WIDTH ===
      sheet.columns = [
        { width: 18 },
        { width: 22 },
        { width: 22 },
        { width: 18 },
        { width: 14 },
        { width: 14 },
      ];

      // === EXPORT BLOB (FOR EMAIL) ===
      const buffer = await workbook.xlsx.writeBuffer();
      const blob = new Blob([buffer], {
        type:
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      return blob;

    } catch (error) {
      console.error("Erreur génération Excel email :", error);
      throw error;
    }
  },
  downloadFacturePDF: async (id) => {
    try {
      // Récupérer les données complètes de la facture
      const facture = await factureService.getFacture(id);
      await factureService.generatePDF(facture);
      return true;
    } catch (error) {
      console.error(`Erreur lors du téléchargement du PDF de la facture ${id}:`, error);
      throw error;
    }
  },

  // Exporter une facture en Excel
  exportFactureToExcel: async (id) => {
    try {
      // Récupérer les données complètes de la facture
      const facture = await factureService.getFacture(id);
      await factureService.generateExcel(facture);
      return true;
    } catch (error) {
      console.error(`Erreur lors de l'exportation Excel de la facture ${id}:`, error);
      throw error;
    }
  },


  // Générer et télécharger une facture en PDF

  generatePDF: async (facture) => {
    try {
      const { jsPDF } = await import('jspdf');
      const html2canvas = (await import('html2canvas')).default;
      const monthNames = [
        "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
        "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
      ];

      function numberToFrenchDirhams(number) {
        const units = [
          "", "un", "deux", "trois", "quatre", "cinq",
          "six", "sept", "huit", "neuf", "dix",
          "onze", "douze", "treize", "quatorze",
          "quinze", "seize", "dix-sept", "dix-huit", "dix-neuf"
        ];

        const tens = [
          "", "", "vingt", "trente", "quarante",
          "cinquante", "soixante", "soixante",
          "quatre-vingt", "quatre-vingt"
        ];

        function convertBelow100(n) {
          if (n < 20) return units[n];
          const ten = Math.floor(n / 10);
          const unit = n % 10;

          if (ten === 7 || ten === 9) {
            return tens[ten] + "-" + units[10 + unit];
          }

          if (unit === 0) return tens[ten];
          if (unit === 1 && ten !== 8) return tens[ten] + "-et-un";

          return tens[ten] + "-" + units[unit];
        }

        function convertBelow1000(n) {
          if (n < 100) return convertBelow100(n);

          const hundred = Math.floor(n / 100);
          const rest = n % 100;

          let result = hundred === 1 ? "cent" : units[hundred] + " cent";

          if (rest > 0) result += " " + convertBelow100(rest);

          return result;
        }

        function convertNumber(n) {
          if (n === 0) return "zéro";

          const thousands = Math.floor(n / 1000);
          const rest = n % 1000;

          let words = "";

          if (thousands > 0) {
            if (thousands === 1) {
              words += "mille";
            } else {
              words += convertBelow1000(thousands) + " mille";
            }
          }

          if (rest > 0) {
            words += (words ? " " : "") + convertBelow1000(rest);
          }

          return words;
        }

        const words = convertNumber(Math.round(number));
        return words.charAt(0).toUpperCase() + words.slice(1) + " Dirhams";
      }
      const pageDiv = document.createElement('div');
      pageDiv.style.cssText = `
      width: 794px;
      height: 1122px;
      background: white;
      font-family: Arial, sans-serif;
      border-left: 20px solid #D94F2A;
      padding: 40px;
      box-sizing: border-box;
      line-height: 1.6;
      letter-spacing: 1px;
      position: relative;
      display: flex;
      flex-direction: column;
    `;

      pageDiv.innerHTML = `
      <div style=" height: 100%; padding: 6px; box-sizing: border-box; display: flex; flex-direction: column; justify-content: space-between;">
      <div>
            <div style="margin-bottom:30px;">
              <div style="display:flex;justify-content:space-between;align-items:flex-start;">
                <div>
                  <img src="${imageLogo}" style="height:40px;margin-bottom:10px;" />            
                </div>
                <div style="text-align:right;">
                <p style="font-size:8px;margin:0;">Facture N° : ${facture.numero_facture}</p>
                <p style="font-size:8px;margin:0;">Date : ${new Date(facture.date_facture).toLocaleDateString()}</p>
                </div>
              </div>
            </div>

          <div style="display:flex; justify-content:space-between; margin-bottom:40px; width:100%;">              
                <div style="width:40%; margin-bottom:30px;">
                  <h3 style="color:#D94F2A; margin-bottom:5px;">Coordonnées client</h3>
                  <p style="margin:0;"><strong>${facture.client?.Raison_sociale || facture.client?.Nom || 'NA'}</strong></p>
                  <p style="margin:0;">${facture.client?.Adresse || 'Adresse non renseignée'}</p>
                  <p style="margin:0;">ICE : ${facture.client?.ICE || 'NA'}</p>
                </div>

                <div style="width:40%; margin-bottom:30px; text-align:left;">
                  <h3 style="color:#D94F2A; padding-bottom:5px; margin-bottom:15px;">
                    Coordonnées bancaires
                  </h3>
                  <p style="margin:0;">RIB : 007 640 0002508000001585 78</p>
                  <p style="margin:0;">Domiciliation : Attijariwafa bank Ag. TANGER BEETHOVEN</p>
                </div>

              </div>

         

          <table style="width: 100%; border-collapse: collapse; margin-bottom: 40px; font-size: 14px;">
            <thead>
              <tr>
                <th style="padding: 10px; text-align: left; border: 1px solid #ccc; background: #f5f5f5;">Description</th>
                <th style="padding: 10px; text-align: center; border: 1px solid #ccc; background: #f5f5f5;">Qté</th>
                <th style="padding: 10px; text-align: center; border: 1px solid #ccc; background: #f5f5f5;">Prix unitaire</th>
                <th style="padding: 10px; text-align: center; border: 1px solid #ccc; background: #f5f5f5;">TOTAL</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style="padding: 10px; border: 1px solid #ccc;">${facture.description || `Transport national Du Mois de ${monthNames[new Date(facture.date_facture).getMonth()]}`}</td>
                <td style="padding: 10px; text-align: center; border: 1px solid #ccc;">1</td>
                <td style="padding: 10px; text-align: center; border: 1px solid #ccc;">${Number(facture.montant_ht || 0).toFixed(2)} MAD</td>
                <td style="padding: 10px; text-align: center; border: 1px solid #ccc;">${Number(facture.montant_ht || 0).toFixed(2)} MAD</td>
              </tr>
            </tbody>
          </table>

         <div style="width: 300px; margin-left: auto; font-size: 14px; border: 1px solid #ccc; border-radius: 6px; padding: 15px;">
          <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
            <tr>
              <td style="padding: 5px 0;">Montant HT (MAD) :</td>
              <td style="text-align: right;">${Number(facture.montant_ht || 0).toFixed(2)}</td>
            </tr>
            <tr>
              <td style="padding: 5px 0;">TVA :</td>
              <td style="text-align: right;">${Number(facture.montant_tva || 0).toFixed(2)}</td>
            </tr>
            <tr style="font-weight: bold; border-top: 1px solid #ccc;">
              <td style="padding: 5px 0;">Montant TTC (MAD) :</td>
              <td style="text-align: right;">${Number(facture.montant_ttc || 0).toFixed(2)}</td>
            </tr>
          </table>
         </div>

          <div style="margin-top: 20px;">
            <p style="margin: 0;font-size: 10px;">Arrêté la présente facture à la somme de ${numberToFrenchDirhams(facture.montant_ttc) || 'NA'}</p>
          </div>
        </div>

        <!-- VISA Section -->
        <div style="width: 100%; height: 100px; border: 1px solid #000; margin: 20px 0; display: flex; align-items: center; justify-content: center;">
          <div style="text-align: center;">
            <p style="margin: 0; font-size: 18px; font-weight: bold;">VISA ADV </p>
            
          </div>
        </div>

        <!-- Footer -->
        <div style="font-size: 9px; text-align: center; color: #666; border-top: 1px solid #ccc; padding-top: 10px;">
          <p>RC 83815 &nbsp;&nbsp;&nbsp; IF 2453806-1 &nbsp;&nbsp;&nbsp; CNSS 1622515 &nbsp;&nbsp;&nbsp; ICE 001966468000060</p>
          <p>EBN.LOGISTICS@GMAIL.COM &nbsp;&nbsp;&nbsp; www.ebnlogistics.com</p>
          <p>41, rue Desaix, Casablanca, Maroc</p>
        </div>
      </div>
    `;

      document.body.appendChild(pageDiv);

      const pdf = new jsPDF('p', 'mm', 'a4');
      const canvas = await html2canvas(pageDiv, { scale: 2, useCORS: true });
      const imgData = canvas.toDataURL('image/png');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const imgProps = pdf.getImageProperties(imgData);
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      document.body.removeChild(pageDiv);

      pdf.save(`facture-${facture.numero_facture}.pdf`);
      return true;
    } catch (error) {
      console.error('Erreur PDF :', error);
      throw error;
    }
  },

  generateExcelOperations: async (facture, imageLogoBase64 = null) => {
    try {
      const workbook = new ExcelJS.Workbook();
      const sheet = workbook.addWorksheet("Liste opérations");

      // === LOGO (OPTIONAL) ===
      if (imageLogoBase64) {
        const logoId = workbook.addImage({
          base64: imageLogoBase64,
          extension: "png",
        });
        sheet.addImage(logoId, "A1:B3");
      }

      // === TITRE ===
      sheet.mergeCells("D1:F1");
      const titleCell = sheet.getCell("D1");
      titleCell.value = `LISTE DES OPERATIONS ${new Date(
        facture.date_facture
      ).toLocaleDateString("fr-FR")}`;
      titleCell.font = { bold: true, color: { argb: "FFFFFFFF" }, size: 12 };
      titleCell.fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "1D3E62" },
      };
      titleCell.alignment = { horizontal: "center", vertical: "middle" };

      // === COMMANDE N° ===
      sheet.mergeCells("D3:E3");
      sheet.getCell("D3").value = "COMMANDE N°";
      sheet.getCell("D3").alignment = { horizontal: "center", vertical: "middle" };
      sheet.getCell("D3").border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      sheet.getCell("F3").value = facture.numero_facture || "";
      sheet.getCell("F3").alignment = { horizontal: "center", vertical: "middle" };
      sheet.getCell("F3").border = {
        top: { style: "thin" },
        left: { style: "thin" },
        bottom: { style: "thin" },
        right: { style: "thin" },
      };

      // === HEADER ROW ===
      sheet.addRow([]);
      const headerRow = sheet.addRow([
        "Date chargement",
        "Expéditeur",
        "Destinataire",
        "Type moyen",
        "Prix HT",
        "N° CMR",
      ]);

      headerRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "1D3E62" },
        };
        cell.font = { color: { argb: "FFFFFF" }, bold: true };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      // === DATA ROWS ===
      facture.lignes.forEach(({ voyage }) => {
        if (!voyage) return;

        sheet.addRow([
          voyage.Date_chargement
            ? new Date(voyage.Date_chargement).toLocaleDateString("fr-FR")
            : "",
          voyage.Expediteur || "",
          voyage.Destinataire || "",
          voyage.Type_de_moyen || "",
          voyage.Coût_Total != null
            ? voyage.Coût_Total.toLocaleString("fr-FR", {
              minimumFractionDigits: 2,
            })
            : "",
          voyage.N_CMR || "",
        ]);

        if (voyage.Immobilisation?.toLowerCase() === "oui") {
          sheet.addRow([
            "", "", "", "Immobilisation",
            voyage.Prix_Immobilisation?.toLocaleString("fr-FR", {
              minimumFractionDigits: 2,
            }) || "",
            "",
          ]);
        }

        if (voyage.Prestation?.toLowerCase() === "oui") {
          sheet.addRow([
            "", "", "", "Prestation",
            voyage.Prix_Prestation?.toLocaleString("fr-FR", {
              minimumFractionDigits: 2,
            }) || "",
            "",
          ]);
        }
      });

      // === STYLE DATA ===
      sheet.eachRow((row, rowNumber) => {
        if (rowNumber > headerRow.number) {
          row.eachCell((cell) => {
            cell.border = {
              top: { style: "thin" },
              left: { style: "thin" },
              bottom: { style: "thin" },
              right: { style: "thin" },
            };
            cell.alignment = { horizontal: "center", vertical: "middle" };
          });
        }
      });

      // === TOTAL HT ROW ===
      const totalRow = sheet.addRow([
        "", "", "", "TOTAL HORS TAXE",
        facture.montant_ht?.toLocaleString("fr-FR", {
          minimumFractionDigits: 2,
        }) || "",
        "",
      ]);

      totalRow.eachCell((cell) => {
        cell.fill = {
          type: "pattern",
          pattern: "solid",
          fgColor: { argb: "1D3E62" },
        };
        cell.font = { color: { argb: "FFFFFF" }, bold: true };
        cell.alignment = { horizontal: "center", vertical: "middle" };
        cell.border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      });

      // === SUMMARY TABLE ===
      const summaryStartRow = sheet.lastRow.number + 2;

      // Summary table headers
      sheet.getCell(`D${summaryStartRow}`).value = "Récapitulatif";
      sheet.getCell(`D${summaryStartRow}`).font = { bold: true, size: 12 };
      sheet.getCell(`D${summaryStartRow}`).fill = {
        type: "pattern",
        pattern: "solid",
        fgColor: { argb: "D94F2A" },
      };
      sheet.getCell(`D${summaryStartRow}`).font = { color: { argb: "FFFFFF" }, bold: true };
      sheet.getCell(`D${summaryStartRow}`).alignment = { horizontal: "center", vertical: "middle" };
      sheet.mergeCells(`D${summaryStartRow}:F${summaryStartRow}`);

      // Total HT
      sheet.getCell(`D${summaryStartRow + 1}`).value = "Total HT :";
      sheet.getCell(`D${summaryStartRow + 1}`).font = { bold: true };
      sheet.getCell(`D${summaryStartRow + 1}`).alignment = { horizontal: "right", vertical: "middle" };
      sheet.getCell(`E${summaryStartRow + 1}`).value = facture.montant_ht?.toLocaleString("fr-FR", {
        minimumFractionDigits: 2,
      }) || "0.00";
      sheet.getCell(`E${summaryStartRow + 1}`).alignment = { horizontal: "right", vertical: "middle" };
      sheet.mergeCells(`E${summaryStartRow + 1}:F${summaryStartRow + 1}`);

      // TVA
      sheet.getCell(`D${summaryStartRow + 2}`).value = "TVA :";
      sheet.getCell(`D${summaryStartRow + 2}`).font = { bold: true };
      sheet.getCell(`D${summaryStartRow + 2}`).alignment = { horizontal: "right", vertical: "middle" };
      sheet.getCell(`E${summaryStartRow + 2}`).value = facture.montant_tva?.toLocaleString("fr-FR", {
        minimumFractionDigits: 2,
      }) || "0.00";
      sheet.getCell(`E${summaryStartRow + 2}`).alignment = { horizontal: "right", vertical: "middle" };
      sheet.mergeCells(`E${summaryStartRow + 2}:F${summaryStartRow + 2}`);

      // Total TTC
      sheet.getCell(`D${summaryStartRow + 3}`).value = "Total TTC :";
      sheet.getCell(`D${summaryStartRow + 3}`).font = { bold: true };
      sheet.getCell(`D${summaryStartRow + 3}`).alignment = { horizontal: "right", vertical: "middle" };
      sheet.getCell(`E${summaryStartRow + 3}`).value = facture.montant_ttc?.toLocaleString("fr-FR", {
        minimumFractionDigits: 2,
      }) || "0.00";
      sheet.getCell(`E${summaryStartRow + 3}`).alignment = { horizontal: "right", vertical: "middle" };
      sheet.getCell(`E${summaryStartRow + 3}`).font = { bold: true, color: { argb: "D94F2A" } };
      sheet.mergeCells(`E${summaryStartRow + 3}:F${summaryStartRow + 3}`);

      // Add borders to summary table
      for (let i = 0; i <= 3; i++) {
        sheet.getCell(`D${summaryStartRow + i}`).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
        sheet.getCell(`E${summaryStartRow + i}`).border = {
          top: { style: "thin" },
          left: { style: "thin" },
          bottom: { style: "thin" },
          right: { style: "thin" },
        };
      }

      // === FOOTER ===
      const footerRow = sheet.lastRow.number + 2;
      sheet.mergeCells(`A${footerRow}:F${footerRow}`);
      sheet.getCell(`A${footerRow}`).value =
        "RC: 83815 - IF: 24838061 - CNSS: 162251 - ICE: 001966468000060 - EBN.LOGISTICS@GMAIL.COM";
      sheet.getCell(`A${footerRow}`).alignment = {
        horizontal: "center",
        vertical: "middle",
      };

      // === COLUMN WIDTHS ===
      sheet.columns = [
        { width: 18 },
        { width: 22 },
        { width: 22 },
        { width: 18 },
        { width: 14 },
        { width: 14 },
      ];

      // === EXPORT ===
      const buffer = await workbook.xlsx.writeBuffer();
      saveAs(
        new Blob([buffer]),
        `liste-operations-${facture.numero_facture}.xlsx`
      );
    } catch (error) {
      console.error("Erreur génération Excel :", error);
      throw error;
    }
  },
};

export default factureService;